import { useTranslation } from "react-i18next";
import { supportedLanguages, type Lang } from "../i18n";

const labels: Record<Lang, string> = {
  en: "EN",
  it: "IT",
  de: "DE",
  fr: "FR",
};

export default function LangSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage as Lang) ?? "en";
  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      {supportedLanguages.map((lng) => (
        <button
          key={lng}
          className={current === lng ? "active" : ""}
          onClick={() => i18n.changeLanguage(lng)}
          aria-pressed={current === lng}
        >
          {labels[lng]}
        </button>
      ))}
    </div>
  );
}
